// extracted by mini-css-extract-plugin
export var gif = "_bz-0";